/** @format */

import { Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from 'src/app/core/services/alert.service';
import { CommonService } from 'src/app/core/services/common.service';
import { DbService } from 'src/app/core/services/db.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { PushService } from '../core/services/push.service';

@Component({
  selector: 'app-push-modal',
  templateUrl: './push-modal.component.html',
  styleUrls: ['./push-modal.component.scss'],
})
export class PushModalComponent {
  @Input() uuids: string[];
  @Input() type: string; // push(선택 push) , allPush (전체 push)

  content: string;
  constructor(
    public modalService: NgbModal,
    private alert: AlertService,
    private pushService: PushService,
    private notification: NotificationService,
    private db: DbService,
    private common: CommonService
  ) {}

  ngOnInit(): void {}

  //푸시 알림 전송
  async sendPush() {
    const ok = await this.alert.successConfirm('선택하신 고객에게 푸시 알림을 전송하시겠어요? \n탈퇴 인원에게는 전송되지 않습니다.', '전송하기');
    if (ok) {
      const id = this.common.generateFilename();
      let obj = {
        dateCreated: new Date().toISOString(),
        title: '더 미션',
        content: this.content,
        type: 'pushNotice',
        refId: id,
      };
      const pushNotice = {
        id,
        dateCreated: obj.dateCreated,
        title: obj.title,
        content: obj.content,
        sendMembers: [],
        checkMembers: [],
      };
      for await (let uuid of this.uuids) {
        let tmp = {
          ntfTitle: obj.title,
          ntfContent: obj.content,
          dateCreated: new Date().toISOString(),
          readSwitch: false,
          noticeId: pushNotice.id,
          type: 'push',
        };
        await this.notification.noticeSystemToMember(tmp, uuid);
        pushNotice.sendMembers.push(uuid);
        this.pushService.memberPush(obj, uuid);
      }

      await this.db.updateAt(`pushNotices/${pushNotice.id}`, pushNotice);
      this.alert.successmsg('', '전송했습니다.');
      this.modalService.dismissAll();
    }
  }

  close() {
    this.modalService.dismissAll();
  }
}
